// pms-adapters / supabase / fiscalVersion — the fiscal software version shown in the UI
// (LNE/BYCYB référentiel E21; migration 20261013140100). One RPC, `pms_fiscal_version()`, granted to signed-in
// users only.

import { ok, type FiscalVersion, type Result } from '@lemontaigu/pms-core';
import { toPmsError, type SupabaseClient } from './support.js';

export class SupabaseFiscalVersion implements FiscalVersion {
  constructor(private readonly db: SupabaseClient) {}

  async read(): Promise<Result<string>> {
    const r = await this.db.rpc('pms_fiscal_version');
    if (r.error) return { ok: false, error: toPmsError(r.error) };
    return ok(String(r.data));
  }
}
